import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { addOrganisationsSwitch } from '@api/organisationSwitch';

import { IId } from '@interfaces/common/common';

import { ORGANISATIONS, ORGANIZATIONS_SWITCH } from '@constants/queryKeys';

interface IUseMutateAddOrganisationSwitchReturned {
	addOrganisationSwitch: UseMutateFunction<any, any, IId, any>;
	isLoadingAddOrganisationSwitch: boolean;
}

export const useMutateAddOrganisationSwitch = (): IUseMutateAddOrganisationSwitchReturned => {
	const queryClient = useQueryClient();

	const {
		mutate: addOrganisationSwitch,
		isLoading: isLoadingAddOrganisationSwitch,
	} = useMutation<IId>({
		mutationKey: [ORGANISATIONS],
		mutationFn: addOrganisationsSwitch,
		onSuccess: () => {
			return queryClient.invalidateQueries([ORGANIZATIONS_SWITCH]);
		},
	});

	return {
		addOrganisationSwitch,
		isLoadingAddOrganisationSwitch,
	};
};
